import {CONFIGURATION_INITIALIZER} from '../../../initializers/ActiveBrandInitializer';
import {LOADER_OFF, LOADER_ON} from "../../loader/service/loaderStatus";
import '../main.scss';
import {
    CalculationNotificationServiceName,
    OpportunityNotificationToggleServiceName,
    PageTitleServiceName
} from "../../utils/names/serviceNames";
import {
    OpportunityNotificationToggleService
} from "../../opportunities_notification/service/OpportunityNotificationToggleService";
import {CalculationsNotificationService} from "../../opportunities_service/service/CalculationsNotificationService";
import {UserAccessRole} from "../../users/model/UserAccessRole";
import {PageTitleService} from "../service/page-title.service";

export const MAIN_CONTROLLER = [
    '$scope',
    '$mdSidenav',
    'LoaderStatusValue',
    CalculationNotificationServiceName,
    OpportunityNotificationToggleServiceName,
    PageTitleServiceName,
    MainController
];
const SIDENAV_ID = "left";

export function MainController($scope,
                               $mdSidenav,
                               LoaderService,
                               notificationService: CalculationsNotificationService,
                               toggleService: OpportunityNotificationToggleService,
                               titleService: PageTitleService) {
    $scope.loaderActive = LoaderService.status;
    $scope.active = false;
    $scope.loaderActive = false;
    $scope.showNotifications = false;
    $scope.logoPath = process.env.LOGO_PATH ? process.env.LOGO_PATH : "/app/images/logos/toolbar_logos/nflp_toolbar_logo.svg"
    $scope.faviconPath = process.env.FAVICON_PATH ? process.env.FAVICON_PATH : "/app/favicon.png?v=1"

    $scope.toggleSidenav = () => {
        $mdSidenav(SIDENAV_ID).toggle();
    };

    $scope.$on(LOADER_ON, function () {
        $scope.loaderActive = true;
    });

    $scope.$on(LOADER_OFF, function () {
        $scope.loaderActive = false;
    });

    $scope.hideNotifications = () => {
        toggleService.updateToggleValue(false);
        $scope.$apply();
    };

    titleService.currentTitle = {
        name: 'Simpl CRM'
    };
    $scope.currentTitle = titleService.currentTitle;
    notificationService.getNumberOfNotifications().then(resp => {
        notificationService.updateNumberOfNotifications(resp.data);
    });

    notificationService.getNumberOfNotificationsObservable().subscribe(numberOfNotifications => {
        $scope.numberOfNotifications = numberOfNotifications;
    });

    toggleService.getToggleValueObservable().subscribe(toggleValue => {
        $scope.showNotifications = toggleValue
    });

    activate();

    function activate() {
        CONFIGURATION_INITIALIZER
            .getPrinciple()
            .then((resp) => {
                let principle = resp;
                $scope.showBrandPicker = principle.accessLevel === UserAccessRole.CORPORATE;
                $scope.principal = principle;
                $scope.brandConfigration = {};
                $scope.active = true;
                $scope.$apply();
            });
    }


}